/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
import apiClient from './client';

// Le segnalazioni del tecnico (migrazioni 015 e 016): vede e commenta solo le
// proprie; stato e priorita' li decide l'ufficio.
export const segnalazioniAPI = {
  list: async (params = {}) => {
    const { data } = await apiClient.get('/segnalazioni', { params });
    return data;
  },

  detail: async (id) => {
    const { data } = await apiClient.get(`/segnalazioni/${id}`);
    return data;
  },

  crea: async (payload) => {
    const { data } = await apiClient.post('/segnalazioni', payload);
    return data;
  },



  commenta: async (id, commento) => {
    const { data } = await apiClient.post(`/segnalazioni/${id}/commenti`, { commento });
    return data;
  },

  elimina: async (id) => {
    const { data } = await apiClient.delete(`/segnalazioni/${id}`);
    return data;
  },

  // `file` e' un File o un Blob (l'audio registrato). Il nome serve al server
  // solo come etichetta: quello sul disco lo decide lui.
  caricaAllegato: async (id, file, nome, durataSecondi) => {
    const fd = new FormData();
    fd.append('file', file, nome || file.name || 'allegato');
    if (durataSecondi !== undefined && durataSecondi !== null) fd.append('durata_secondi', String(durataSecondi));
    const { data } = await apiClient.post(`/segnalazioni/${id}/allegati`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 120000,
    });
    return data;
  },

  // Gli allegati passano dalla rotta autenticata: un <audio src> non manda il
  // token, quindi si scarica il file come blob e si usa un URL locale.
  scaricaAllegato: async (aid) => {
    const { data } = await apiClient.get(`/segnalazioni/allegati/${aid}`, { responseType: 'blob' });
    return data;
  },

  eliminaAllegato: async (aid) => {
    const { data } = await apiClient.delete(`/segnalazioni/allegati/${aid}`);
    return data;
  },
};
